import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const ReportsList = styled.ul`
  list-style: none;

  li {
    margin-bottom: ${themeSpace(1)};
  }
`;

ReportsList.displayName = 'ReportsList';
